/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2024. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2024. Todos los derechos reservados.
 */

import {TableColumnAlignEnum, TableColumnEnum, TableColumnInterface} from '@shared/components/table';

/**
 * @description
 * Header array for sensors table
 */
export const ICONS_MAIN_HEADERS: TableColumnInterface[] = [
  {
    field: 'icon_class',
    type: TableColumnEnum.icon,
    header: 'app.setting.icons.fields.icon',
    align: TableColumnAlignEnum.center,
    grow: 0.3
  },
  {
    field: 'icon_class',
    type: TableColumnEnum.text,
    header: 'app.setting.icons.fields.nameClass.label',
    align: TableColumnAlignEnum.center,
  },
  {
    field: 'description',
    type: TableColumnEnum.text,
    header: 'app.setting.icons.fields.description.label',
    align: TableColumnAlignEnum.center,
  },
];
